import { useRouter } from "next/router";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { IScope } from "@nju/scope";
import { BlockText, Button, Separator } from "@nju/ui";

interface IEmptyCalendar {
  variant: IScope;
}

export function EmptyCalendar({ variant }: IEmptyCalendar) {
  const router = useRouter();

  return (
    <div className="flex items-center flex-col only-mobile:px-4 pt-8">
      <Icon height={85} name="calendar-alt-incricle-fail" width={85} />
      <Separator size="s" tone="invisible" />
      <BlockText align="center">
        W tej chwili nie mamy dostępnych terminów instalacji.{" "}
        {variant !== "sales" &&
          `Wróć do swojego
        profilu i spróbuj ponownie później.`}
      </BlockText>
      {variant !== "sales" && (
        <>
          <Separator size="s" tone="invisible" />
          <Button
            display="block"
            onPress={() => {
              router.push(portalRoutes.mojeKonto.mojProfil.index.get());
            }}
            size="s"
          >
            mój profil
          </Button>
        </>
      )}
    </div>
  );
}
